function takeSamplePhoto(sampleId, windowTitle) {
  window.webcam.start(
    `/upload_photo/${sampleId}/sample`,
    windowTitle || "Take Picture of Sample",
    false
  );
}

function takeAliquotPhoto(aliquotId, windowTitle) {
  window.webcam.start(
    `/upload_photo/${aliquotId}/aliquot`,
    windowTitle || "Take Picture of Aliquot",
    false
  );
}

export { takeSamplePhoto, takeAliquotPhoto };
